import { FC } from 'react';

interface TetherIconProps {
  width?: string;
  height?: string;
  useGreyIcon?: boolean;
}

const TetherIcon: FC<TetherIconProps> = ({ width = '24', height = '24', useGreyIcon = false }) => {
  if (!useGreyIcon) {
    return (
      <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="tether-icon">
          <path
            id="white-bg"
            d="M2.3999 10.7998L5.9999 4.7998H17.9999L21.5999 10.7998L11.9999 20.3998L2.3999 10.7998Z"
            fill="white"
          />
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.31838 3.6001H18.9399C19.2649 3.6001 19.5652 3.76852 19.7272 4.04176L23.6958 10.7314C23.9016 11.0784 23.8405 11.5162 23.5469 11.7976L12.6235 22.2661C12.2696 22.6052 11.7004 22.6052 11.3465 22.2661L0.43791 11.8117C0.13754 11.5238 0.0812936 11.0732 0.30217 10.7241L4.54418 4.02029C4.7094 3.75921 5.00256 3.6001 5.31838 3.6001ZM17.1811 6.58681V8.46383H13.3009V9.76523C16.0261 9.9043 18.0707 10.4755 18.0859 11.1601L18.0858 12.5874C18.0706 13.272 16.0261 13.8432 13.3009 13.9823V17.1761H10.7244V13.9823C7.99917 13.8432 5.95455 13.272 5.93937 12.5874L5.93948 11.1601C5.95463 10.4755 7.99917 9.9043 10.7244 9.76523V8.46383H6.84415V6.58681H17.1811ZM12.0126 13.0018C14.9209 13.0018 17.3517 12.5188 17.9466 11.8738C17.4421 11.3268 15.6174 10.8963 13.3009 10.7781V12.1407C12.8857 12.1619 12.4547 12.173 12.0126 12.173C11.5706 12.173 11.1396 12.1619 10.7244 12.1407V10.7781C8.40782 10.8963 6.58311 11.3268 6.07864 11.8738C6.67354 12.5188 9.10435 13.0018 12.0126 13.0018Z"
            fill="#009393"
          />
        </g>
      </svg>
    );
  }

  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.09084 4.7998H25.2529C25.6862 4.7998 26.0866 5.02437 26.3027 5.38868L31.5941 14.3083C31.8684 14.7708 31.787 15.3547 31.3956 15.7297L16.831 29.6878C16.3592 30.1399 15.6002 30.1399 15.1284 29.6878L0.583554 15.7486C0.18306 15.3648 0.108066 14.7639 0.402568 14.2985L6.05858 5.36007C6.27887 5.01195 6.66976 4.7998 7.09084 4.7998ZM22.9078 8.78209V11.2848H17.7342V13.02C21.3678 13.2054 24.094 13.967 24.1142 14.8799L24.1141 16.7829C24.0938 17.6957 21.3678 18.4573 17.7342 18.6427V22.9011H14.2988V18.6427C10.6652 18.4573 7.93907 17.6957 7.91884 16.7829L7.91898 14.8799C7.93918 13.967 10.6652 13.2054 14.2988 13.02V11.2848H9.12521V8.78209H22.9078ZM16.0165 17.3353C19.8942 17.3353 23.1353 16.6913 23.9285 15.8313C23.2559 15.1021 20.8229 14.5281 17.7342 14.3705V16.1872C17.1806 16.2155 16.6059 16.2304 16.0165 16.2304C15.4271 16.2304 14.8524 16.2155 14.2988 16.1872V14.3705C11.2101 14.5281 8.77715 15.1021 8.10453 15.8313C8.89773 16.6913 12.1388 17.3353 16.0165 17.3353Z"
        fill="white"
        fillOpacity="0.3"
      />
    </svg>
  );
};

export default TetherIcon;
